// @packages
import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// @scripts
import Schedule from './ScheduleDisplay';
import {
    addItemToScheduleImport,
    removeItemsFromSchedule,
    sendScheduleItemsToEdge,
    updateItemFromSchedule
} from '../../actions';

const ScheduleContainer = ({
    onAddItemToScheduleImport,
    onRemoveItemsFromSchedule,
    onCommitItemFromSchedule,
    scheduleItems,
    sessionId
}) => (
    <Schedule
        id="schedule-page"
        onAddItemToScheduleImport={onAddItemToScheduleImport}
        onRemoveItemsFromSchedule={onRemoveItemsFromSchedule}
        onSendScheduleItemsToEdge={sendScheduleItemsToEdge}
        onCommitItemFromSchedule={onCommitItemFromSchedule}
        scheduleItems={scheduleItems}
        sessionId={sessionId}
    />
);

ScheduleContainer.propTypes = {
    onRemoveItemsFromSchedule: PropTypes.func.isRequired,
    onAddItemToScheduleImport: PropTypes.func.isRequired,
    onCommitItemFromSchedule: PropTypes.func.isRequired,
    scheduleItems: PropTypes.array.isRequired,
    sessionId: PropTypes.string
};

ScheduleContainer.defaultProps = {
    sessionId: null
};

const mapStateToProps = ({ product, user }) => ({
    scheduleItems: product.scheduleItems,
    sessionId: user.sid
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    onAddItemToScheduleImport: addItemToScheduleImport,
    onRemoveItemsFromSchedule: removeItemsFromSchedule,
    onCommitItemFromSchedule: updateItemFromSchedule
}, dispatch);

export default connect(
    mapStateToProps, mapDispatchToProps
)(ScheduleContainer);
